import { Link } from "react-router-dom";
import { categories } from "@/mocks/content";

export default function CategorySection() {
  return (
    <section className="w-full px-4 py-14 md:px-8 md:py-20" aria-labelledby="category-title">
      <div className="mb-8 max-w-2xl">
        <p className="text-xs font-medium uppercase tracking-[0.2em] text-primary-600">
          Categories
        </p>
        <h2
          id="category-title"
          className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl"
        >
          按主题分类吃瓜
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-foreground-600">
          六大方向覆盖主流娱乐话题，可以按自己的兴趣快速定位，也可以从分类页系统地回看近期事件。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/events?cat=${cat.id}`}
            className="group flex items-start gap-4 rounded-lg border border-background-200/80 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-primary-50/60"
          >
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-xl text-secondary-800 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={cat.icon}></i>
            </span>
            <span className="min-w-0 flex-1">
              <span className="flex items-center justify-between">
                <span className="font-heading text-base font-semibold text-foreground-950">
                  {cat.name}
                </span>
                <span className="text-xs text-foreground-400">{cat.count} 条</span>
              </span>
              <span className="mt-1.5 block text-sm leading-relaxed text-foreground-600">
                {cat.desc}
              </span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}